<template>
	<div class="md-layout">
		<div class="md-layout-item md-size-66">
			<form ref="document_add" @submit.prevent="addDocument">
				<md-card>
					<md-card-header class="md-card-header-icon md-card-header-blue">
						<div class="card-icon">
							<md-icon>add</md-icon>
						</div>
						<h4 class="title">Ajout d'un document</h4>
					</md-card-header>
					<document-form :document="document" :errors="errors"></document-form>
					<md-card-actions md-alignment="left">
						<md-button type="submit" class="md-success">
							Enregistrer
						</md-button>
						<md-button class="md-warning"
								   @click="goBack">
							Retour
						</md-button>
					</md-card-actions>
				</md-card>
			</form>
		</div>
	</div>
</template>

<script>
import DocumentForm from "@/pages/Documents/components/DocumentForm";

export default {
	name: "DocumentAdd",
	components: {
		DocumentForm
	},
	data() {
		return {
			document: {
				order: 0
			},
			isBigger: false,
			errors: []
		}
	},
	methods: {
		async addDocument() {
			// if "undefined", file's size > 5Mo
			if(this.document.file) {
				let formData = new FormData()
				formData.append('file', this.document.file)
				formData.append('fileName', this.formatFileName(this.document.file))
				try {
					this.errors = [];
					const { data } = await this.$store.dispatch('documents/uploadDocument', formData)
					let pathParts = data.split('/')
					let document = {
						name: this.document.name,
						typeId: this.document.type,
						order: parseInt(this.document.order),
						description: this.document.description ?? '',
						filePath: pathParts[3]
					}
					await this.$store.dispatch('documents/addDocument', document)
					await this.$store.dispatch("alerts/success", "Document ajouté")
					this.goBack()
				} catch (e) {
					this.errors = e.response.data.errors
				}
			} else {
				await this.$store.dispatch("alerts/warning", "Attention : vérifier la présence et le poids du fichier")
			}
		},
		async getDocumentTypes() {
			let { data } = await this.$store.dispatch('documents/getDocumentTypes')
			this.typeList = data.filter(type => type.parent_id === null)
		},
		formatFileName(file) {
			let regex = /[ ]|'/g // search space and apostrophe
			return Math.floor(Math.random() * (9999 - 1000 + 1) + 1000) + '-' +
				file.name.toLowerCase().replaceAll(regex, '-')
		},
		goBack() {
			this.$router.go(-1)
		}
	},
	mounted() {
		this.getDocumentTypes()
	}
}
</script>

<style scoped lang="scss">

</style>
